import {UuidOptionColor, ViewBy} from '@/domain/services/Clas';

export const APP_NAME = 'clas';
export const DRAWER_WIDTH = 360;
export const SM_BREAKPOINT = 600;
export const MINI_SIDE_PANEL_DENSE_WIDTH = 45;

export const INITIAL_VIEWPORT = {
  latitude: 43.3705,
  longitude: -5.2062,
  zoom: 13,
  bearing: 0,
  pitch: 0
};

export const SIDEPANEL_CONTENT_ID: Record<string, string> = {
  LAYERS: 'layers',
  FILTERS: 'filters',
};

export const MAIN_CONTENT_ID = {
  DASHBOARD: 'dashboard',
  MAP: 'map'
};

export const PNOA_HISTORICO_ID = 'pnoa-historico';
export const PNOA_DEFAULT_YEAR = 2006;

export const MAPSTYLES = [
  {
    label: 'PNOA',
    thumbnail: '/mapstyles/pnoa.png',
    id: '/mapstyles/pnoa.json'
  },
  {
    id: PNOA_HISTORICO_ID,
    label: 'PNOA Histórico',
    thumbnail: '/mapstyles/pnoa.png'
  },
  {
    label: 'IGN Claro',
    thumbnail: 'https://vts.larioja.org/styles/rioja-claro/8/126/94.png',
    id: 'https://vts.larioja.org/styles/rioja-claro/style.json'
  },
  {
    label: 'IGN',
    thumbnail: 'https://vts.larioja.org/styles/rioja/8/126/94.png',
    id: 'https://vts.larioja.org/styles/rioja/style.json'
  }
];

export const INITIAL_MAPSTYLE = MAPSTYLES[2];

export const PNOA_YEARS = [
  {
    value: 2006,
    label: '2006'
  },
  {
    value: 2009,
    label: '2009'
  },
  {
    value: 2011,
    label: '2011'
  },
  {
    value: 2014,
    label: '2014'
  },
  {
    value: 2017,
    label: '2017'
  },
  {
    value: 2020,
    label: '2020'
  }
];

export const MAP_DETAILS = {
  REDNATURA: 'redNatura',
  CATASTRO: 'catastro',
  PROTECTION: 'protection' 
};

type MAP_DETAIL_STYLES_COLORS_TYPE = {
  id: number | string,
  name: string,
  type: string,
  paint: {
    color: string,
    opacity: number | undefined
  }
}

type MAP_DETAIL_STYLES_TYPE = {
  id: string,
  label: string,
  thumbnail: string,
  legendUrl?: string,
  colors: Array<MAP_DETAIL_STYLES_COLORS_TYPE>,
  width?: number
}

export const FILTER_KEY = {
  YEAR: 'year' ,
  USER_UUID: 'userUuid',
  MUNICIPALITY: 'municipalityUuid',
  CROP: 'cropUuid',
  USE: 'useUuid',
  PROTECTION_TYPE: 'protectionType',
  ENP_TYPE: 'enpType',
  RN_TYPE: 'rnType',
  MAB_TYPE: 'isMab'
};

export const FIELD_PROPERTIES = {
  MUNICIPALITIES: 'municipalities',
  CROPS: 'crops',
  USES: 'uses',
  BYDEFAULT: 'byDefault'
};

export const MAP_DETAIL_STYLES: Array<MAP_DETAIL_STYLES_TYPE> = [
  {
    id: MAP_DETAILS.REDNATURA,
    label: 'Red Natura',
    thumbnail: '/mapstyles/redNatura.png',
    legendUrl: 'https://wms.mapama.gob.es/sig/Biodiversidad/RedNatura/Leyenda/RedNatura.png',
    width: 100,
    colors: [
      {
        id: 1,
        name: 'Forestal MVMC',
        type: 'fill',
        paint: {
          color: '#5cb816',
          opacity: 1
        }
      }
    ]
  },
  {
    id: MAP_DETAILS.PROTECTION,
    label: 'Inventario Español de Áreas Protegidas',
    thumbnail: '/mapstyles/protection.png',
    legendUrl: 'https://wms.mapama.gob.es/sig/Biodiversidad/IEAAPP/Leyenda/IEAAPP.png',
    width: 230,
    colors: [
      {
        id: 1,
        name: 'Protection',
        type: 'fill',
        paint: {
          color: '#FABADA',
          opacity: 1
        }
      }
    ]
  },
  {
    id: MAP_DETAILS.CATASTRO,
    label: 'Catastro',
    thumbnail: '/mapstyles/cadastre.png',
    colors: [
      {
        id: 1,
        name: 'Cadastre',
        type: 'fill',
        paint: {
          color: '#5cb816',
          opacity: 1
        }
      }
    ]
  }
];

export type PRIVATE_LAYER = {
  id: string,
  label: string,
  thumbnail: string,
  legendUrl: string
  width: number
}

export const PRIVATE_LAYER = {
  GROUND_COVERS: 'go_geprocar%3Agogeprocar_clasificacion_coberturas',
  SOIL_ORGANIC_CARBON: 'go_geprocar%3Agogeprocar_soc',
  SOIL_ORGANIC_CARBON_PARCEL: 'go_geprocar%3Arecintos_clas_soc',
  ABANDONED_PARCELS: 'go_geprocar%3Arecintos_clas_abandonadas'
};

export const PRIVATE_LAYERS: Array<PRIVATE_LAYER> = [
  {
    id: PRIVATE_LAYER.GROUND_COVERS,
    label: 'Coberturas del suelo',
    thumbnail: '/mapstyles/cover.png',
    legendUrl: 'http://ide.cetemas.es/geoserver/go_geprocar/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=gogeprocar_clasificacion_coberturas',
    width: 100,
  },
  {
    id: PRIVATE_LAYER.SOIL_ORGANIC_CARBON,
    label: 'Carbono orgánico del suelo (t/ha)',
    thumbnail: '/mapstyles/soc.png',
    legendUrl: 'https://ide.cetemas.es/geoserver/go_geprocar/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=gogeprocar_soc',
    width: 100,
  },
  {
    id: PRIVATE_LAYER.SOIL_ORGANIC_CARBON_PARCEL,
    label: 'Carbono orgánico del suelo (t/ha) (Parcela)',
    thumbnail: '/mapstyles/soc_parcel.png',
    legendUrl: 'https://ide.cetemas.es/geoserver/go_geprocar/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=recintos_clas_soc',
    width: 100,
  },
  {
    id: PRIVATE_LAYER.ABANDONED_PARCELS,
    label: 'Parcelas abandonadas',
    thumbnail: '/mapstyles/abandoned_parcel.png',
    legendUrl: 'https://ide.cetemas.es/geoserver/go_geprocar/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=recintos_clas_abandonadas',
    width: 100,
  }
];

export const OWNERS: Array<UuidOptionColor> = [
  { uuid: 'USER', name: 'Mis recintos', color: '#bd4e68' },
  { uuid: 'OTHERS', name: 'Otros', color: '#246f91' }
];

export const VIEW_BY_OPTIONS: Record<string, string> = {
  DEFAULT: ViewBy.DEFAULT,
  USE: ViewBy.USE,
  CROP: ViewBy.CROP,
  USER: ViewBy.USER
};


export const ROLE = {
  ADMIN: 'ADMIN',
  USER: 'USER'
};

export const PROTECTION_TYPES = [
  {id: 'YES', label: 'Protección: Sí'},
  {id: 'NO', label: 'Protección: No'},
  {id: 'PARTIAL', label: 'Protección: Parcial'}
];

export const MAB_TYPES = [
  {id: 'YES', label: 'Reserva de la Biosfera: Sí'},
  {id: 'NO', label: 'Reserva de la Biosfera: No'}
];
